export default "__VITE_ASSET__D5BV$QMK__"